import React from "react";
import { inject, observer } from "mobx-react";
import { IAppStore } from "../../stores/Interfaces";
import { RoleType } from "../../constants/authorize";

interface Props {
  store?: IAppStore;
  role: RoleType;
  children: React.ReactElement;
}

const WithoutRole: React.FC<Props> = ({ store, role, children }) => {
  if (store?.userStore.authorizeByRole(role) === false) {
    return children;
  }

  return null;
};

export default inject("store")(observer(WithoutRole));
